import { LucideProps } from 'lucide-react';

export const ArrowTopRightIcon = (props: LucideProps) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.53516 14.9323L14.8685 6.599M14.8685 6.599H6.53516M14.8685 6.599V14.9323"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
